var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhramacyApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_11890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_11890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 25.6667V23.3333H22.6667V11.6667H6.33332V16.3333H3.99999V7.00001C3.99999 6.35834 4.22846 5.80904 4.68541 5.35209C5.14235 4.89515 5.69166 4.66668 6.33332 4.66668H7.49999V2.33334H9.83332V4.66668H19.1667V2.33334H21.5V4.66668H22.6667C23.3083 4.66668 23.8576 4.89515 24.3146 5.35209C24.7715 5.80904 25 6.35834 25 7.00001V23.3333C25 23.975 24.7715 24.5243 24.3146 24.9813C23.8576 25.4382 23.3083 25.6667 22.6667 25.6667H18ZM9.83332 28L8.19999 26.3667L11.2042 23.3333H1.66666V21H11.2042L8.19999 17.9667L9.83332 16.3333L15.6667 22.1667L9.83332 28ZM6.33332 9.33334H22.6667V7.00001H6.33332V9.33334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhramacyApp);
export default __webpack_public_path__ + "static/media/PhramacyApp.a3d538dde87fdd7199a0e79d9b68762d.svg";
export { ForwardRef as ReactComponent };